import { render, staticRenderFns } from "./InTheNews.vue?vue&type=template&id=02bce95e&"
import script from "./InTheNews.vue?vue&type=script&lang=js&"
export * from "./InTheNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports